<template>
    <div id="editar-modalidades">
        <el-row :gutter="20" type="flex" justify="center" align="middle">
            <el-col :span="18" class="titulo">
                Editar Modalidades
            </el-col>
        </el-row>
        <el-row :gutter="20" type="flex" justify="center" align="middle">
            <el-col :span="22" class="cuerpo">

                <v-alert v-if="estado" type="success" color="green" style="margin-bottom:30px" :value="true">
                    Los Cambios se Guardaron Correctamente.
                </v-alert>
                <v-alert v-if="error" type="error" color="red" style="margin-bottom:30px" :value="true">
                    Ha ocurrido un error intentando procesar su solicitud.<br>Por favor, intente nuevamente.
                </v-alert>


                <!-- MODALIDADES -->
                <el-form ref="fm" :model="ModalidadesTodas">
                    <el-row>
                        <center><strong>Modalidades</strong></center><br>
                        <el-checkbox v-for="(nivel, index) in ModalidadesTodas"
                        :key="index" v-model="nivel.Checked" class="el-col el-col-xs-24 el-col-sm-11">
                            {{ nivel.Nombre }}
                        </el-checkbox>
                    </el-row>
                    <el-row :gutter="20" justify="space-between" style="width:100%; margin-top:30px">
                        <el-col :xs="24" :sm="12" :md="8" style="float:right; margin-bottom:10px; margin-top:-5px">
                            <v-btn 
                                raised 
                                block
                                color="blue" 
                                :loading="cargando" 
                                @click="ModalidadesSubmit()"
                                style="color:#fff"
                            >
                                Guardar Cambios
                            </v-btn>
                        </el-col>
                        <el-col :xs="24" :sm="12" :md="8" style="float:left">
                            <router-link class="el-col el-col-24 el-button el-button--danger"
                            :to="{ name: 'datos' }">
                                Volver
                            </router-link>
                        </el-col>
                    </el-row>
                </el-form>
            </el-col>
        </el-row>
    </div>
</template>


<script>
    import axios from 'axios';

    export default
    {   data()
        {   return {
                //Publicos
                Tipo:               this.$route.params.id,
                cargando:           false,
                estado:             false,
                error:              false,

                //Modalidades
                ModalidadesTodas:   [],
            }
        },


        methods:
        {   ModalidadesSubmit()
            {   this.cargando       = true;
                this.estado         = false;
                this.error          = false;

                var params  = '';
                var headers = new Headers();
                headers.append('Content-Type', 'application/x-www-form-urlencoded');

                params  = params + '&tkn=' + this.$cookies.get('PDTK');
                params  = params + '&modalidades=' + JSON.stringify(this.ModalidadesTodas);
                
                axios.post('https://docentes.educaciondigitaltuc.gob.ar/aphpi/doc_modalidades_up.php', params, {headers: headers})
                    .then(response => {
                        const datos             = response.data
                        this.estado             = datos['estado'];
                        this.error              = datos['error'];
                        this.cargando           = false;
                        window.scrollTo(0,0);
                    })
                    .catch(e => {
                        this.error              = true;
                    })
            }
        },


        beforeMount()
        {   if(!this.$cookies.get('PDTK'))
            {   this.$router.push('../login');
            }
            else
            {   var params  = 'tkn=' + this.$cookies.get('PDTK');
                var headers = new Headers();
                headers.append('Content-Type', 'application/x-www-form-urlencoded');
                
                axios.post('https://docentes.educaciondigitaltuc.gob.ar/aphpi/doc.php', params, {headers: headers})
                    .then(response => {
                        const datos             = response.data
                        this.ModalidadesTodas   = datos['modalidades_todas'];
                    })
                   /* .catch(e => {})*/
            }
        }
    };
</script>


<style>
    .el-checkbox, .el-checkbox__input
    {   margin-left: 0px !important;
    }
</style>
